var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,19V5c0-1.657,1.343-3,3-3h7l6,6v11c0,1.657-1.343,3-3,3H7C5.343,22,4,20.657,4,19z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,6V2l6,6h-4C14.895,8,14,7.105,14,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/defaultFile.dd465539ad3f4eb5c9de6c373365d38d.svg";
export { ForwardRef as ReactComponent };